import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ClaimsLayout from './ClaimsLayout';
import ClaimsRelabel from './ClaimsRelabel';

const ClaimsRelabelPage = ({ posConfig }) => {
    return (
        <Routes>
            <Route path="/" element={<ClaimsLayout />}>
                <Route index element={<ClaimsRelabel posConfig={posConfig} />} />
            </Route>
        </Routes>
    );
};

export default ClaimsRelabelPage;
